import {SimpleChipExpression} from "@nrwl/query-emitter";

export class DrillDirectionEvent {
  type: 'new' | 'append' | 'reset' | 'readonly';
  expressions: Array<SimpleChipExpression>;
  // for us, drill direction event is always unique - even if looking at object properties,
  // it might seem 'identical' from value.exchange.provider point of view.
  // to be sure it never supresses our events, each event object is assigned a random, unique UUID.
  cacheBreaker;

  constructor(type, expressions) {
    this.type = type;
    this.expressions = expressions;
    this.cacheBreaker = Math.random().toString(36).substr(2);
  }
}

export const DRILL_DIRECTION = 'drill_direction';
export const TF_DRILL_DIRECTION = 'tf_drill_direction';
